module.exports = __webpack_public_path__ + "static/media/Proforma.c24e512b.png";